/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { Comment } from './comment';
import { DataPlanTimespan } from './dataPlanTimespan';
import { StringTimespan } from './stringTimespan';
import { LongTimespan } from './longTimespan';
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { ComProviderTimespan } from './comProviderTimespan';
import { CollarBuild } from './collarBuild';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CollarDto { 
    idDevice?: number;
    id?: number;
    insertTs?: string;
    updateTs?: string;
    deviceTypeId?: string;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    parameterDataList?: Array<ParameterData>;
    warranty?: string;
    testDevice?: boolean;
    userSubsystemVisibility?: Array<boolean>;
    batteryTimeline?: Array<StringTimespan>;
    pcbTypeId?: string;
    gpsPlusDevice?: boolean;
    buildInProduction?: CollarBuild;
    currentBuild?: CollarBuild;
    previousBuilds?: Array<CollarBuild>;
    comments?: Array<Comment>;
    replacedById?: number;
    nfcTagUid?: string;
    comType?: CollarDto.ComTypeEnum;
    comIdTimeline?: Array<StringTimespan>;
    comId?: string;
    knownToSendBrokenMessages?: boolean;
    comProviderTimeline?: Array<ComProviderTimespan>;
    dataPlanTimeline?: Array<DataPlanTimespan>;
    networkStatusTimeline?: Array<NetworkStatusTimespan>;
    paymentAccountTimeline?: Array<LongTimespan>;
    airtimeNetworkStatusChangeRequested?: CollarDto.AirtimeNetworkStatusChangeRequestedEnum;
    schedules?: Array<Schedule>;
    lastReceivedCommandTime?: string;
    commandCount?: number;
    internalDropOffId?: number;
    externalDropOffId?: number;
    vhfBeaconTransmitterId?: number;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
    roofTestCompleted?: string;
    color?: string;
    lowBatteryStatus?: CollarDto.LowBatteryStatusEnum;
    _class: string;
}
export namespace CollarDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
    export const LowBatteryStatusEnum = {
        Alert: 'ALERT',
        Resolved: 'RESOLVED'
    } as const;
    export type LowBatteryStatusEnum = typeof LowBatteryStatusEnum[keyof typeof LowBatteryStatusEnum];
}


